import {get, post} from "@/utils/http";

let baseURL = "/seal";
let baseURL2 = "/sealApply";

// 分页查询印章列表
const getSealPage = data => get(`${baseURL}/getSealPage`, data);
// 编辑印章信息审批信息
const editFlowInfo = data => post(`${baseURL}/editFlowInfo`, { data });
// 添加或编辑印章信息
const addSealInfo = data => post(`${baseURL}/addSealInfo`, { data });
// 删除印章信息
const deleteSealInfo = data => post(`${baseURL}/deleteSealInfo`, { data });
// 根据登录用户获取印章列表
const getSealList = () => get(`${baseURL}/getSealList`);
// 分页查询盖章申请记录
const getSealRecordPage = data => get(`${baseURL}/getSealRecordPage`, data);
// 已批准待盖章申请列表
const getSealApplyList = () => get(`${baseURL}/getSealApplyList`);

// 提交盖章申请
const applyInfo = data => post(`${baseURL}/applyInfo`, { data });

// 保存盖章申请信息
const saveInfo = data => post(`${baseURL}/saveInfo`, { data });

// 审核通过
const approveApply = data => post(`${baseURL}/approveApply`,  { data });

// 审核拒绝
const rejectApply = data => post(`${baseURL}/rejectApply`, { data });

//删除盖章申请
const deleteSealApplyInfo = data => post(`${baseURL2}/deleteSealApplyInfo`, { data });

const getFlowBySealId = data => get(`${baseURL}/getFlowBySealId`, data);

// sealAPI
export default {
    getSealPage,
    addSealInfo,
    deleteSealInfo,
    getSealList,
    getSealRecordPage,
    getSealApplyList,
    applyInfo,
    saveInfo,
    approveApply,
    rejectApply,
    deleteSealApplyInfo,
    editFlowInfo,
    getFlowBySealId
};
